import {
  I18N_SUBMIT_CONFIRMATION_BUTTON_KEY,
  I18N_SUBMIT_DISCLAIMER_KEY,
  I18N_WARNINGS_CHECK_LABEL_KEY
} from 'lf-at-theme';

/**
 * App i18n object for the pt-PT locale.
 */

export const appI18NPtPT: Record<string, any> = {
  '*': {
    saveFileName: 'oss-registo-intermediario',
    [I18N_SUBMIT_DISCLAIMER_KEY]: 'Está prestes a submeter o seu registo no Regime Importação como Intermediário. Deseja continuar?',
    [I18N_SUBMIT_CONFIRMATION_BUTTON_KEY]: 'Submeter',
    [I18N_WARNINGS_CHECK_LABEL_KEY]: 'Confirmo que tomei conhecimento dos alertas produzidos pelos dados desta declaração.',
    ["modalYesBtn"]: 'Confirmar',
    ["modalNoBtn"]: 'Cancelar',
    ["schemeConditionsTitle"]: 'Condições de acesso',
    ["schemeConditions"]: `
      <p>Para se registar como intermediário deve verificar se reúne as seguintes condições:</p>
      <ul>
        <li>Ser sujeito passivo estabelecido no território nacional.</li>
        <li>Ter a intenção de agir em nome e por conta de outro(s) sujeito(s) passivo(s).</li>
        <li>Cumprir todas as obrigações do regime em nome daqueles que irá representar.</li>
      </ul>
    `,
  }
};
